define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader'],
    function($, transit, modernizr, container, preloader)
    {

        return (function() {

            const name = 'legal';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            //const pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {
            };

            model.privateVars = {
            };

            model.methods = {

            };

            /* view */

            view.publicVars = {
            };

            view.privateVars = {
                menu: {
                    headerMenuAnim: false,
                    headerMenuOpened: false,
                }
            };

            view.startup = function() {

            };

            view.bind = function() {
                $(view.publicVars.cssId.menu.categoryMenuIconWrapperId).click(function () {
                    const width = $(window).width();

                    if(width < 600) {
                        if (!view.privateVars.menu.headerMenuAnim) {
                            view.privateVars.menu.headerMenuAnim = true;
                            view.methods.menu.handleMenu();
                        }
                    }
                });
            };

            view.methods = {
                menu: {
                    handleMenu: () => {
                        if (!view.privateVars.menu.headerMenuOpened) {
                            view.methods.menu.handleMenuOpen();
                        } else {
                            view.methods.menu.handleMenuClose();
                        }
                    },

                    handleMenuOpen: () => {
                        view.privateVars.menu.headerMenuOpened = true;

                        $(view.publicVars.cssId.menu.categoryMenuId).slideDown(300, () => {
                            view.privateVars.menu.headerMenuAnim = false;
                        });
                    },

                    handleMenuClose: () => {
                        view.privateVars.menu.headerMenuOpened = false;


                        $(view.publicVars.cssId.menu.categoryMenuId).slideUp(300, () => {
                            view.privateVars.menu.headerMenuAnim = false;
                            $(view.publicVars.cssId.menu.categoryMenuId).removeAttr('style');
                        });
                    },
                }
            };

            /* custom events */
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function(options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();

    });